module.exports = __webpack_public_path__ + "img/b_intro_4_cn.6ddf09c.png";